


































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import ClickOutside from 'vue-click-outside'
import Editor from '@/components/Editor.vue'
import KeyValueEditor from '@/components/KeyValueEditor.vue'
import convertPayload from '@/utils/convertPayload'
import { getMessageId } from '@/utils/idGenerator'
import _ from 'lodash'
import validFormatJson from '@/utils/validFormatJson'
import time from '@/utils/time'
import { emptyToNull } from '@/utils/handleString'
import { getConnectionPushProp, updateConnectionPushProp } from '@/utils/api/connection'
import historyMessageHeaderService from '@/utils/api/historyMessageHeaderService'
import historyMessagePayloadService from '@/utils/api/historyMessagePayloadService'

@Component({
  components: {
    Editor,
    KeyValueEditor,
  },
  directives: {
    ClickOutside,
  },
})
export default class MsgPublish extends Vue {
  @Prop({ required: true }) public editorHeight!: number
  @Prop({ required: true }) public subsVisible!: boolean
  @Prop({ default: false }) public mqtt5PropsEnable!: boolean

  @Getter('currentTheme') private currentTheme!: Theme

  private MQTT5PropsForm: PushPropertiesModel = {}

  private MQTT5PropsSend: PushPropertiesModel = {}

  private showMetaCard: boolean = false

  private saveMetaLoading = false

  private topicRequired = false
  private topicInvalid = false

  private getHasMqtt5PropState() {
    return (
      Object.entries(this.MQTT5PropsForm).filter(([_, v]) => v !== null && v !== undefined && v !== false).length > 0
    )
  }

  private async saveMeta() {
    this.hasMqtt5Prop = this.getHasMqtt5PropState()
    this.saveMetaLoading = true
    await this.updatePushProp()
    this.saveMetaLoading = false
    this.showMetaCard = false
  }

  private changeVisable() {
    this.showMetaCard = !this.showMetaCard
  }

  get rules() {
    return {}
  }

  private hasMqtt5Prop: boolean = false

  private headersHistory: HistoryMessageHeaderModel[] | [] = []
  private payloadsHistory: HistoryMessagePayloadModel[] | [] = []
  private historyIndex: number = -1
  private defaultMsgRecord: MessageModel = {
    createAt: time.getNowDate(),
    out: true,
    qos: 0,
    retain: false,
    topic: '',
    payload: JSON.stringify({ msg: 'hello' }, null, 2),
  }
  private msgRecord: MessageModel = _.cloneDeep(this.defaultMsgRecord)
  private headerValue: HistoryMessageHeaderModel = {
    qos: this.msgRecord.qos,
    retain: this.msgRecord.retain,
    topic: this.msgRecord.topic,
  }

  private payloadLang = 'json'
  private payloadType: PayloadType = 'JSON'
  private payloadOptions: PayloadType[] = ['Plaintext', 'Base64', 'JSON', 'Hex']

  @Watch('editorHeight')
  private handleHeightChanged() {
    this.handleLayout()
  }
  @Watch('subsVisible')
  private handleSubsChanged(val: boolean) {
    setTimeout(() => {
      this.handleLayout()
    }, 500)
  }
  @Watch('payloadType')
  private handleTypeChange(val: PayloadType, oldVal: PayloadType) {
    const { payload } = this.msgRecord
    if (val === 'JSON') {
      this.payloadLang = 'json'
    } else {
      this.payloadLang = 'plaintext'
    }
    if (payload === '') {
      return
    }
    convertPayload(payload, val, oldVal)
      .then((res) => {
        this.msgRecord.payload = res
      })
      .catch((error: Error) => {
        const errorMsg = error.toString()
        this.$message.error(errorMsg)
        this.payloadType = oldVal
      })
  }
  @Watch('historyIndex', { immediate: true, deep: true })
  private handleHistoryIndexChange(val: number, lastval: number) {
    if (lastval !== val && val >= 0 && val < this.payloadsHistory.length) {
      this.msgRecord = Object.assign(this.msgRecord, this.payloadsHistory[val])
      this.payloadType = this.payloadsHistory[val].payloadType
    }
  }
  /**
   * Notice:
   * when we jump order by`creation page` <-> `connection page`,
   * the monaco will not init or destroy, because we use the v-show to hidden Msgpublish componment.
   * So we need to operate editor creation and destroy manually by listening on route.
   * relative PR: https://github.com/emqx/MQTTX/pull/518 https://github.com/emqx/MQTTX/pull/446
   */
  @Watch('$route.params.id', { immediate: true, deep: true })
  private async handleIdChanged(to: string, from: string) {
    const editorRef = this.$refs.payloadEditor as Editor
    if (to && from === '0' && to !== '0') {
      // Init the editor when rout jump from creation page
      editorRef.initEditor()
    } else if (from && from !== '0' && to === '0') {
      // destroy the editor when rout jump to creation page
      editorRef.destroyEditor()
    }
    this.loadProperties()
  }

  @Watch('mqtt5PropsEnable')
  private async handleMqtt5Enable(val: boolean) {
    if (val) {
      this.loadProperties()
    }
  }

  private handleHeaderChange(val: HistoryMessageHeaderModel) {
    if (val) {
      const { retain, topic, qos } = val
      Object.assign(this.msgRecord, { retain, topic, qos })
    }
  }

  // Notice: add editor creation and destroy manually export for it's father componment.
  public editorDestory() {
    const editorRef = this.$refs.payloadEditor as Editor
    editorRef.destroyEditor()
  }

  public editorInit() {
    const editorRef = this.$refs.payloadEditor as Editor
    editorRef.initEditor()
  }

  private async updatePushProp() {
    this.MQTT5PropsForm = emptyToNull(this.MQTT5PropsForm)
    this.MQTT5PropsSend = _.cloneDeep(this.MQTT5PropsForm)
    const propRecords = Object.entries(this.MQTT5PropsForm).filter(([_, v]) => v !== null && v !== undefined && v !== 0)
    const props = Object.fromEntries(propRecords)
    return await updateConnectionPushProp(this.$route.params.id, props)
  }

  private send() {
    this.msgRecord.id = getMessageId()
    this.msgRecord.createAt = time.getNowDate()
    this.mqtt5PropsEnable && (this.msgRecord.properties = this.MQTT5PropsSend)
    this.$emit('handleSend', this.msgRecord, this.payloadType, this.loadHistoryData)
  }

  private async loadHistoryData(isNewPayload?: boolean, isLoadData?: boolean) {
    const payloadsHistory = await historyMessagePayloadService.getAll()
    const headersHistory = await historyMessageHeaderService.getAll()
    const historyMsg = payloadsHistory[payloadsHistory.length - 1]
    if (historyMsg && isLoadData) {
      this.payloadType = historyMsg.payloadType
    }
    this.headersHistory = headersHistory
    this.payloadsHistory = payloadsHistory
    if (isNewPayload) {
      this.historyIndex = this.payloadsHistory.length - 1
    }
  }

  private async loadData() {
    await this.loadHistoryData(false, true)
    this.historyIndex = this.payloadsHistory.length - 1
    Object.assign(
      this.msgRecord,
      this.defaultMsgRecord,
      this.headersHistory[this.headersHistory.length - 1],
      this.payloadsHistory[this.payloadsHistory.length - 1],
    )
    const headersHistoryIndex = this.payloadsHistory[this.historyIndex]
    if (headersHistoryIndex) {
      this.payloadType = headersHistoryIndex.payloadType
    }
    this.loadProperties()
  }

  private async loadProperties() {
    this.MQTT5PropsForm = {}
    if (this.mqtt5PropsEnable) {
      const pushProps = await getConnectionPushProp(this.$route.params.id)
      if (pushProps) {
        this.MQTT5PropsForm = pushProps
        this.MQTT5PropsSend = _.cloneDeep(this.MQTT5PropsForm)
        this.hasMqtt5Prop = this.getHasMqtt5PropState()
      }
    }
  }

  public setTopicRequired(isRequired = true) {
    this.topicRequired = isRequired
  }

  public setTopicInvalid(isInvalid = true) {
    this.topicInvalid = isInvalid
  }

  private clearTopicValidationErrors() {
    if (this.topicRequired) {
      this.topicRequired = false
    }
    if (this.topicInvalid) {
      this.topicInvalid = false
    }
  }

  private handleInputFocus() {
    this.clearTopicValidationErrors()
    this.$emit('focus')
  }

  private handleInputBlur() {
    this.clearTopicValidationErrors()
  }

  private handleLayout() {
    const editorRef: EditorRef = this.$refs.payloadEditor as EditorRef
    editorRef.editorLayout()
  }

  private formatJsonValue() {
    const jsonValue = validFormatJson(this.msgRecord.payload)
    if (jsonValue) {
      this.msgRecord.payload = jsonValue
    }
  }

  private created() {
    this.loadData()
  }

  private decrease() {
    this.historyIndex = this.historyIndex - 1 >= 0 ? this.historyIndex - 1 : 0
  }

  private back() {
    this.historyIndex = this.payloadsHistory.length - 1
  }

  private increase() {
    this.historyIndex =
      this.historyIndex + 1 <= this.payloadsHistory.length - 1 ? this.historyIndex + 1 : this.payloadsHistory.length - 1
  }

  private handleClickOutSide() {
    this.showMetaCard = false
  }
}
